import { render, staticRenderFns } from "./EducationalCategoryChangeActivationType.vue?vue&type=template&id=f63c98e0&"
import script from "./EducationalCategoryChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports